import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import { courseList } from "../../api/Courses";
import Master from "./Master";
import { batchList } from "../../api/Batch";
import { differenceInDays, formatToDate, formatToTime } from "../master/FormatToDateTime";
import { printElement } from "../master/Print";
import { StaffList } from "../../api/Staff";
import { studentAttendanceListAnnual, studentAttendanceListAnnualV4 } from "../../api/Attendance";

export default function StudentAttendancesAnnual() {
    const [loading, setLoading] = useState("");
    const [data, setData] = useState([]);
    const [courses, setCourses] = useState([]);
    const [batches, setBatches] = useState([]);
    const [staffs, setStaffs] = useState([]);
    const [sessions, setSessions] = useState([]);
    const [filters, setFilters] = useState({
    });


    useEffect(() => {
        const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
        setSessions(parseSessions);
    }, []);

    useEffect(() => {
        const activeSession = sessions?.find((s) => Number(s.status) === 1)?.id;
        setFilters((prev) => {
            if (prev.session_id || !activeSession) return prev;
            return {
                ...prev,
                session_id: activeSession,
            };
        });
    }, [sessions]);

    const getCourse = async () => {
        setLoading(true);
        try {
            const response = await courseList();
            if (response.data.status) {
                setCourses(response.data.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message,
            );
        } finally {
            setLoading(false);
        }
    };
    const getStaffs = async () => {
        setLoading(true);
        try {
            const response = await StaffList(`status=1`);
            if (response.data.status) {
                setStaffs(response.data.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    const getBatches = async () => {
        setLoading(true);
        try {
            let addUrl = ``;
            if (filters?.session_id) {
                addUrl += `&session_id=${filters?.session_id}`;
            }
            if (filters?.course_id) {
                addUrl += `&course_id=${filters?.course_id}`;
            }
            const response = await batchList(addUrl);
            if (response.data.status) {
                setBatches(response?.data?.data);
            } else {
                SweetAlertShow("info", "warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.response?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    const getAttendanceList = async () => {
        if (!filters?.batch_id && !filters?.course_id && !filters?.staff_id) {
            return null;
        }
        setLoading(true);
        let addUrl = "";
        Object.keys(filters).forEach((key) => {
            const value = filters[key];
            if (value) {
                addUrl += `&${key}=${encodeURIComponent(value)}`;
            }
        });
        try {
            const response = await studentAttendanceListAnnualV4(addUrl);
            if (response.data.status) {
                setData(response?.data?.data);
            } else {
                SweetAlertShow("info", "Warning", response?.data?.message);
            }
        } catch (error) {
            SweetAlertShow(
                "error",
                "Error",
                error?.response?.data?.message ?? error?.response?.message,
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAttendanceList();
    }, [filters]);

    useEffect(() => {
        getBatches();
    }, [filters?.course_id]);

    useEffect(() => {
        getCourse();
        getStaffs();
    }, []);

    return (
        <>
            {loading && <LoadingDiv />}
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                        <div className="content-wrapper">
                            <div className="container-fluid flex-grow-1 container-p-y">
                                <div className="row">
                                    <Master />
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row g-2 align-items-center">
                                                    <div className="col-sm-6">
                                                        <h4 className="text-primary m-0">
                                                            Student Attendance Annual
                                                        </h4>
                                                    </div>
                                                    <div className="col-sm-6 text-end"></div>
                                                    <div className="col-sm-2">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select"
                                                                name="session"
                                                                value={filters?.session_id}
                                                                onChange={(e) =>
                                                                    setFilters({
                                                                        ...filters,
                                                                        session_id: e.target.value,
                                                                    })
                                                                }
                                                            >
                                                                {sessions?.map((session) => (
                                                                    <option key={session?.id} value={session?.id}>
                                                                        {session?.session} :{" "}
                                                                        {session?.status === "1"
                                                                            ? "Active"
                                                                            : " Inactive"}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            <label>Session</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select form-control"
                                                                name="course_id"
                                                                value={filters?.course_id}
                                                                onChange={(e) => {
                                                                    setFilters({
                                                                        ...filters,
                                                                        course_id: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">All</option>
                                                                {courses?.map((course, index) => (
                                                                    <option key={index} value={course.id}>
                                                                        {course.title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <label className="ms-5">Course</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select form-control"
                                                                name="batch_id"
                                                                value={filters?.batch_id}
                                                                onChange={(e) => {
                                                                    setFilters({
                                                                        ...filters,
                                                                        batch_id: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">All</option>
                                                                {batches?.map((batch, index) => (
                                                                    <option key={index} value={batch.id}>
                                                                        {batch.title}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <label className="ms-5">Batch</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select form-control"
                                                                name="student_type"
                                                                value={filters?.student_type || ""}
                                                                onChange={(e) => {
                                                                    setFilters({
                                                                        ...filters,
                                                                        student_type: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">All Students</option>
                                                                <option value="hostel">Hostel Students</option>
                                                            </select>
                                                            <label className="ms-5">Student Type</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="form-floating form-floating-outline">
                                                            <select
                                                                className="form-select form-control"
                                                                name="staff_id"
                                                                value={filters?.staff_id}
                                                                onChange={(e) => {
                                                                    setFilters({
                                                                        ...filters,
                                                                        staff_id: e.target.value,
                                                                    });
                                                                }}
                                                            >
                                                                <option value="">All</option>
                                                                {staffs?.map((staff, index) => (
                                                                    <option key={index} value={staff.id}>
                                                                        {staff.name} ({staff.registration_no})
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            <label className="ms-5">Class Teacher</label>
                                                        </div>
                                                    </div>

                                                    <div className="col-1">
                                                        <button
                                                            className="btn btn-outline-danger"
                                                            onClick={() => printElement("PrintDiv", "", 0.6)}
                                                        >
                                                            <i className="ri-printer-line"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card mt-4">
                                            <div className="card-body" id="PrintDiv">
                                                <div className="row align-items-center justify-content-between">
                                                    <div className="col-7 text-center ">
                                                        <h5 className="mb-0 text-primary text-nowrap fw-bold">

                                                        </h5>
                                                    </div>

                                                </div>

                                                <div className="table-responsive">
                                                    <table className="table table-hover table-bordered  text-center">
                                                        <thead>
                                                            <tr className="text-nowrap">
                                                                <th className="p-1">#</th>
                                                                <th className="p-1">
                                                                    <b className="text-nowrap d-block m-0">
                                                                        Name
                                                                    </b>
                                                                    <small className="text-muted m-0">
                                                                        Gender
                                                                    </small>
                                                                </th>
                                                                <th className="p-1">
                                                                    <b className="text-nowrap d-block m-0">
                                                                        Mobile
                                                                    </b>
                                                                    <small className="m-0">Reg No</small>
                                                                </th>
                                                                <th className="p-1">
                                                                    <b className="text-nowrap d-block m-0">
                                                                        Batch & Course
                                                                    </b>
                                                                    <small className="m-0">Admission Date</small>
                                                                </th>

                                                                <th className="p-1">Total Days</th>
                                                                <th className="p-1">Holidays</th>
                                                                <th className="p-1">Working Days</th>
                                                                <th className="p-1">Present</th>
                                                                <th className="p-1">Absent</th>
                                                                <th className="p-1">Not Marks</th>
                                                                <th className="p-1">Average</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {data?.map((item, index) => {
                                                                const admissionDate = formatToDate(item?.latest_course_and_fee?.admission_date ??
                                                                    item?.latest_course_and_fee?.created_at ?? item?.created_at
                                                                    ,
                                                                );

                                                                const totalDays = differenceInDays(
                                                                    new Date(admissionDate),
                                                                    new Date()
                                                                );
                                                                let totalHolidays = 0;

                                                                for (
                                                                    let d = new Date(admissionDate);
                                                                    d <= new Date();
                                                                    d.setDate(d.getDate() + 1)
                                                                ) {
                                                                    const currentDate = formatToDate(d);

                                                                    const hasAttendance = data?.some((student) =>
                                                                        student?.attendances?.some(
                                                                            (attendance) =>
                                                                                formatToDate(attendance?.date) === currentDate
                                                                        )
                                                                    );

                                                                    if (!hasAttendance) {
                                                                        totalHolidays++;
                                                                    }
                                                                }
                                                                const totalWorkingDays = totalDays - totalHolidays;

                                                                const totalPresent =
                                                                    item?.attendances?.reduce(
                                                                        (acc, curr) => acc + (Number(curr.check_in) === 1 ? 1 : 0),
                                                                        0
                                                                    ) ?? 0;

                                                                const totalAbsent =
                                                                    item?.attendances?.reduce(
                                                                        (acc, curr) => acc + (Number(curr.check_in) === 2 ? 1 : 0),
                                                                        0
                                                                    ) ?? 0;

                                                                const totalNotMarks =
                                                                    totalWorkingDays - (totalPresent + totalAbsent);

                                                                return (
                                                                    <tr key={item.id}>
                                                                        <td className="p-1">{index + 1}</td>
                                                                        <td className="p-1">
                                                                            <b className="text-nowrap d-block">
                                                                                {item?.name}
                                                                            </b>
                                                                            <small className="text-muted">
                                                                                {item?.gender}
                                                                            </small>
                                                                        </td>
                                                                        <td className="p-1">
                                                                            <b className="text-nowrap d-block m-0">
                                                                                {item?.phone}
                                                                            </b>
                                                                            <small className="m-0">
                                                                                {item?.registration_no}
                                                                            </small>
                                                                        </td>
                                                                        <td className="p-1">
                                                                            <b className="text-nowrap d-block m-0">
                                                                                {item?.latest_course_and_fee?.batch?.title ?? ''} ({item?.latest_course_and_fee?.course?.title ?? ''})
                                                                            </b>
                                                                            <small className="m-0">
                                                                                {formatToDate(admissionDate)}
                                                                            </small>
                                                                        </td>
                                                                        <td className="p-1">
                                                                            {totalDays}
                                                                        </td>

                                                                        <td className="p-1">
                                                                            {totalHolidays}
                                                                        </td>
                                                                        <td className="p-1">
                                                                            {totalWorkingDays}
                                                                        </td>
                                                                        <td className="p-1">
                                                                            {totalPresent}
                                                                        </td>
                                                                        <td className="p-1">
                                                                            {totalAbsent}
                                                                        </td>
                                                                        <td className="p-1">
                                                                            {totalNotMarks}
                                                                        </td>
                                                                        <td className="p-1">
                                                                            <b>
                                                                                {Math.floor(
                                                                                    (totalPresent / totalWorkingDays) *
                                                                                    100,
                                                                                )}
                                                                                %
                                                                            </b>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
